<script setup lang="ts">
  const props = defineProps<{
    src?: string;
    alt?: string;
    title?: string;
    width?: string | number;
    height?: string | number;
  }>();
  const isFocused = ref(false);

  // Route relative image paths through the server proxy (images live in the
  // private obsidian-vault GitHub repo alongside the .md files).
  const resolvedSrc = computed(() => {
    const src = props.src;
    if (!src) return "";

    // Already absolute — use as-is
    if (/^(https?:)?\/\//.test(src) || src.startsWith("/")) return src;

    // Strip leading "./"
    const clean = src.replace(/^\.\//, "");
    // Obsidian wiki-links produce bare filenames (no "/") — they live in images/
    const withFolder = clean.includes("/") ? clean : `images/${clean}`;
    return `/api/blog-image?path=${encodeURIComponent(`Blogs - Published/${withFolder}`)}`;
  });
</script>

<template>
  <button
    type="button"
    class="block max-w-full cursor-zoom-in"
    :aria-label="`Focus image: ${alt ?? 'figure'}`"
    @click="isFocused = true"
  >
    <img
      :src="resolvedSrc"
      :alt="alt ?? ''"
      :title="title"
      :width="width"
      :height="height"
      class="block h-auto max-w-full rounded-lg"
      loading="lazy"
    />
  </button>

  <ui-image-modal
    v-if="isFocused"
    :src="resolvedSrc"
    :alt="alt ?? 'Focused figure'"
    @close="isFocused = false"
  />
</template>
